<template>
  <div class="main-order-detail">
    <el-card>
      <h1 style="margin-top: 0;margin-bottom:0px">历史订单明细</h1>
      <div class="search-top" style="margin-top:10px">
        <div class="item" style="width: 36%;">
          <div class="button-tag">
            <span :class="{ active: timeType == 0 }" @click="timeType = 0">下单时间</span>
            <span :class="{ active: timeType == 1 }" @click="timeType = 1">结账时间</span>
          </div>
          <el-date-picker style="height: 24px !important;flex: 1;" v-model="dateRange" type="daterange"
            value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
            :picker-options="pickerOptions"></el-date-picker>
        </div>

        <div class="item">
          <span style="margin-right: 8px;width: 80px;text-align: right;">结账方式:</span>
          <el-select clearable class="ddly-select long-select" v-model="queryInfo.condition.payType">
            <el-option label="支付宝" value="alipay"></el-option>
            <el-option label="现金" value="cashier"></el-option>
            <el-option label="会员卡" value="memberCard"></el-option>
            <el-option label="微信" value="wechat"></el-option>
            <el-option label="银通物联一卡通" value="yintong"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span style="margin-right: 8px;width: 80px;text-align: right;">桌台操作:</span>
          <el-select clearable class="ddly-select long-select" v-model="queryInfo.condition.tableCode">
            <el-option :label="item.tableName" :value="item.tableCode" v-for="(item, i) in MerchantAreaList"
              :key="i"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span style="margin-right: 8px;width: 80px;text-align: right;">备注:</span>
          <el-input v-model="queryInfo.condition.orderRemark" style="width:100%"></el-input>
        </div>
        <div class="item">
          <span style="margin-right: 8px;width: 140px;text-align: right;">收货人手机号:</span>
          <el-input v-model="queryInfo.condition.distributorPhone" style="width:100%" clearable></el-input>
        </div>
        <div class="item">
          <span style="margin-right: 8px;width: 80px;text-align: right;">订单号:</span>
          <el-input v-model="queryInfo.condition.orderNumber" style="width:100%" clearable></el-input>
        </div>
        <div class="item" v-if="showMore">
          <span style="margin-right: 8px;width: 80px;text-align: right;">收银员:</span>
          <el-select clearable class="ddly-select long-select" v-model="queryInfo.condition.checkOutUserCode">
            <el-option v-for="(item, i) in userCodeListOptions" :label="`${item.nickName} (${item.loginName})`"
              :value="item.loginName" :key="i"></el-option>
          </el-select>
        </div>
        <div class="item" v-if="showMore">
          <span style="margin-right: 8px;width: 80px;text-align: right;">菜品分类:</span>
          <el-select class="ddly-select long-select"></el-select>
        </div>
        <div class="item" v-if="showMore">
          <span style="margin-right: 8px;width: 80px;text-align: right;">菜品名称:</span>
          <el-select class="ddly-select long-select"></el-select>
        </div>
        <div class="item" v-if="showMore" style="width: 30%;">
          <el-select style="width: 30%;">
            <el-option label="订单金额"></el-option>
          </el-select>
          <el-input-number style="width: 30%;" @change="correct" v-model="queryInfo.condition.minSumToPay"
            controls-position="right" placeholder="最低价格" :min="0"></el-input-number>

          <el-input-number style="width: 30%;" @change="correct" v-model="queryInfo.condition.maxSumToPay"
            controls-position="right" placeholder="最高价格" :min="0"></el-input-number>
        </div>
        <div class="item" v-if="showMore">
          <span style="margin-right: 8px;width: 80px;text-align: right;">用餐方式:</span>
          <el-select class="ddly-select long-select"></el-select>
        </div>
        <div class="item" v-if="showMore">
          <span style="margin-right: 8px;width: 80px;text-align: right;">挂账人:</span>
          <el-select class="ddly-select long-select"></el-select>
        </div>
        <div class="item" v-if="showMore">
          <span style="margin-right: 8px;width: 80px;text-align: right;">桌台区域:</span>
          <el-select class="ddly-select long-select"></el-select>
        </div>
        <div class="item" v-if="showMore">
          <span style="margin-right: 8px;width: 80px;text-align: right;">餐段:</span>
          <el-select class="ddly-select long-select"></el-select>
        </div>
        <div class="item" v-if="showMore">
          <span style="margin-right: 8px;width: 80px;text-align: right;">发票:</span>
          <el-select class="ddly-select long-select"></el-select>
        </div>
        <div class="item" v-if="showMore">
          <span style="margin-right: 8px;width: 80px;text-align: right;">订单类型:</span>
          <el-select class="ddly-select long-select" clearable v-model="queryInfo.condition.orderType">
            <el-option label="线下订单" value="offline"></el-option>
            <el-option label="线上订单" value="online"></el-option>
          </el-select>
        </div>

        <div class="item">
          <span @click="showMore = !showMore"
            style="cursor: pointer;font-weight: 500;color: rgb(255,96,0);transform: translateX(-10px);margin-right: 8px;width: 80px;text-align: right;font-size: 12px;width: 70px">
            <i v-if="showMore" style="font-weight: 500;" class="el-icon-arrow-up"></i>
            <i v-else style="font-weight: 500;" class="el-icon-arrow-down"></i>
            {{ showMore == true ? '收起' : '更多' }}筛选
          </span>
          <el-button class="searchBtn" style="background-color: rgb(255,209,0);color:#333" @click="search">查询
          </el-button>
          <el-button @click="exportXls" type="primary">导出</el-button>
        </div>
      </div>
      <el-button type="primary" class="sumBtn">总计 ：{{ Number(sumTotal.totalPaid).toFixed(2) }}
      </el-button>
      <el-button type="success" class="sumBtn">优惠 ：{{
        (sumTotal.totalSumToPay - sumTotal.totalPaid).toFixed(2)
      }}
      </el-button>
      <el-button type="warning" class="sumBtn">微信 ：{{ sumTotal.wechatPaid }}
      </el-button>
      <el-button type="primary" class="sumBtn">支付宝 ：{{ sumTotal.alipayPaid }}
      </el-button>
      <el-button type="success" class="sumBtn">现金 ：{{ sumTotal.cashierPaid }}
      </el-button>
      <el-button type="warning" class="sumBtn">会员卡 ：{{ sumTotal.memberCardPaid }}
      </el-button>
      <el-button type="primary" class="sumBtn">挂账 ：{{ sumTotal.chargePaid }}
      </el-button>
      <el-button type="success" class="sumBtn">混合支付 ：{{ sumTotal.blendPaid }}
      </el-button>
      <el-button type="warning" class="sumBtn">充值金额 ：{{ sumTotal.totalRecharge }}
      </el-button>
      <!--  -->
      <div class="center-menu">
        <div @click="searchBystatus(item.code)" :class="{
          'center-item': true,
          active: item.code === queryInfo.condition.receiptStatus
        }" v-for="(item, i) in statusMenu" :key="i">
          {{ item.name }}
        </div>
        <div :class="{
          'center-item': true,
          active: queryInfo.condition.isRefund == 1
        }" @click="isRefundBtn">
          已退款
        </div>
      </div>

      <!-- 表格 -->
      <el-table v-loading="tableDloading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.8)" :data="tableData" border height="calc(100vh - 400px)"
        style="width: 100%">
        <el-table-column width="100" type="index" align="center" fixed label="序号"></el-table-column>
        <el-table-column width="100" show-overflow-tooltip prop="orderNumber" align="center" label="订单号">
        </el-table-column>
        <!--         <el-table-column width="180" show-overflow-tooltip align="center" label="订单来源">
          <template slot-scope="scope">
            <span v-if="scope.row.sourceCode == 'cashier'">收银</span>
            <span v-if="scope.row.sourceCode == 'wap'">网页</span>
            <span v-if="scope.row.sourceCode == 'mini'">微信小程序</span>
            <span v-if="scope.row.sourceCode == 'ele'">饿了么</span>
            <span v-if="scope.row.sourceCode == 'meituan'">美团</span>
            <span v-if="scope.row.sourceCode == 'miniScan'">扫码点单</span>
            <span v-if="scope.row.sourceCode == 'wx_jsapi'">微信收款码扫码</span>
            <span v-if="scope.row.sourceCode == 'alipay_jsapi'">支付宝收款码扫码</span>
          </template>
</el-table-column> -->
        <el-table-column align="center" width="180" label="下单时间">
          <template slot-scope="scope">
            {{ scope.row.orderDt | dataFormat }}
          </template>
        </el-table-column>

        <el-table-column align="center" prop="sumPaid" label="订单收入" width="180">
        </el-table-column>
        <el-table-column align="center" prop="payTypeName" label="结账方式" width="180">
        </el-table-column>
        <el-table-column align="center" label="订单状态" width="180">
          <template slot-scope="scope">
            <div class="flexCenter" v-if="scope.row.sourceCode == 'mini'">
              <span>{{ getStatus(scope.row) }}</span>
            </div>
            <div v-else></div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="退款金额" width="180">
          <template slot-scope="scope">
            <span v-if="
              scope.row.refundAmount != null && scope.row.refundAmount != ''
            ">{{ scope.row.refundAmount }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="退款时间" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.refundTime | dataFormat }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="订单类型" prop="deliveryType" width="180">
          <template slot-scope="scope">
            <span style="color:#F38700" v-if="scope.row.deliveryType == '0'">自提订单</span>
            <span style="color:#04A8EF" v-if="scope.row.deliveryType == '1'">配送订单</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="memberName" label="会员" width="180"></el-table-column>
        <el-table-column align="center" width="180" show-overflow-tooltip prop="transNo" label="桌台流水号">
        </el-table-column>
        <el-table-column align="center" prop="tableName" label="桌台区域" width="180">
        </el-table-column>
        <el-table-column class-name="workout" align="center" width="200px" fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button @click="showDialog(scope.row)" v-if="getStatus(scope.row) == '待发货'"
              class="btnTable">去发货</el-button>
            <el-button @click="showDialogRefundBtn(scope.row)" v-if="getStatus(scope.row) == '退款中'"
              class="btnTable">去处理</el-button>
            <el-button @click="goToDetail(scope.row.orderNumber)">查看
            </el-button>
            <el-button v-if="isUpdateOrderTime == 1" @click="updateBtn(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryInfo.currPage" :page-sizes="[10, 20, 30, 50]" :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
    <el-dialog class="mydialog" title="订单详情" :visible.sync="dialogVisible" width="520px">
      <div>
        <el-form>
          <el-form-item label="订单编号">
            <span class="c3">{{ dialogObj.orderNumber }}</span>
          </el-form-item>
          <el-form-item label="订单详情" class="flexContent">
            <div v-for="item, index in dialogObj.arr" :key="index">{{ item.productName }}X{{ item.num }}</div>
          </el-form-item>
          <el-form-item label="收货人">
            <span class="c3">{{ dialogObj.distributorName }}</span>
          </el-form-item>
          <el-form-item label="收货地址">
            <span class="c3">{{ dialogObj.distributorAddress }}</span>
          </el-form-item>
          <el-form-item label="快递单号">
            <el-input v-model="dialogObj.deliveryNo" style="width:200px" placeholder="请输入快递公司"></el-input>
          </el-form-item>
          <el-form-item label="快递公司" class="kuaidi">
            <el-select style="width:200px" filterable v-model="dialogObj.deliveryCompany">
              <el-option v-for="item in delivery_list" :value="item.delivery_name" :label="item.delivery_name"
                :key="item.delivery_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支付金额">
            <span>{{ dialogObj.sumPaid }}</span>
          </el-form-item>
          <el-form-item label="下单时间">
            <span>{{ dialogObj.orderDt | dataFormat }}</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deliverBtn">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 退款 -->
    <el-dialog class="mydialog" title="退款详情" :visible.sync="showDialogRefund" width="520px">
      <div>
        <el-form>
          <el-form-item label="订单编号">
            <span class="c3">{{ dialogObj.orderNumber }}</span>
          </el-form-item>
          <el-form-item label="订单详情" class="flexContent">
            <div v-for="item, index in dialogObj.arr" :key="index">{{ item.productName }}X{{ item.num }}</div>
          </el-form-item>
          <el-form-item label="退款金额">
            <span>{{ dialogObj.sumPaid }}</span>
          </el-form-item>
          <el-form-item label="退款原因">
            <span>{{ dialogObj.refundReason }}</span>
          </el-form-item>
          <el-form-item label="详情图">
            <div v-if="dialogObj.refundImg != null && dialogObj.refundImg.length != 0">
              <el-image v-for="item, index in dialogObj.refundImg" :key="index" style="width: 100px; height: 100px"
                :src="item" :preview-src-list="dialogObj.refundImg">
              </el-image>
            </div>
            <span v-else>无</span>
          </el-form-item>
          <el-form-item label="退款处理">
            <el-radio-group v-model="isAgreeRefund">
              <el-radio :label="true">同意</el-radio>
              <el-radio :label="false">拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialogRefund = false">取 消</el-button>
        <el-button type="primary" @click="refundBtn">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改 -->
    <el-dialog title="修改订单" :visible.sync="updateDialog" width="520px">
      <el-form>
        <el-form-item label="修改支付方式:" class="flex">
          <el-select value-key="payTypeCode" v-model="dialogObjs.payType" style="width:220px">
            <el-option :label="item.payTypeName" :value="item" v-for="item, index in updateList"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="修改订单时间:">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="dialogObjs.payTime" type="datetime"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateDialog = false">取 消</el-button>
        <el-button type="primary" @click="updateSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
// 创建一个表示当前日期的 Date 对象
let currentDate = new Date();

// 获取当前日期的天数
let currentDay = currentDate.getDate();

// 将日期减去一天
currentDate.setDate(currentDay - 1);
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() >= today.getTime();
        }
      },
      isUpdateOrderTime: 0,
      dialogObjs: {
        payType: '',
        payTime: '',
        orderNumber: ''
      },
      updateList: [],
      updateDialog: false,
      delivery_list: [],
      isAgreeRefund: true,
      showDialogRefund: false,
      dialogObj: {
        orderNumber: '',
        distributorAddress: "",
        distributorName: '',
        distributorPhone: '',
        deliveryCompany: '',
        deliveryNo: "",
        orderDt: '',
        sumPaid: '',
        orderDt: '',
        arr: [],
        refundImg: [],
        refundReason: ''
      },
      dialogVisible: false,
      tableDloading: true,
      sumTotal: {},
      totalMoney: '',
      zfb: '',
      wx: '',
      vipCard: '',
      onAccount: '',
      cash: '',
      mix: '',
      versionCode: '',
      MerchantAreaList: '', //桌台操作下拉框
      userCodeListOptions: [], //收银员下拉框
      timeType: 0,
      statusMenu: [
        { name: '全部订单', code: null },
        { name: '待接单', code: 0 },
        { name: '已接单', code: 1 },
        { name: '已退单', code: 2 },
        { name: '已完成', code: 3 }
      ],
      total: 0,
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 50,
        //查询条件
        condition: {
          sourceCode: "",
          merchantCode: '',
          receiptStatus: null, //接单状态 0:待接单,1:已接单,2已退单,3已完成','':全部
          payType: '', //支付方式
          tableCode: '', //桌台操作
          checkOutUserCode: '', //收银员
          isRefund: null
        }
      }, //查询条件
      dateRange: [currentDate, currentDate],
      showMore: false,
      form: {
        orderTime: '',
        dateRange: [], //日期
        sourceCode: '', //订单来源
        minNum: '',
        maxNum: ''
      },
      tableData: []
    }
  },
  methods: {
    updateBtn(obj) {
      this.getUpSelect()
      this.updateDialog = true
      this.dialogObjs.orderNumber = obj.orderNumber
    },
    async updateSubmit() {
      let data = {}
      data.merchantCode = localStorage.getItem('merchantCode')
      data.merchantName = localStorage.getItem('merchantName')
      data.orderNumber = this.dialogObjs.orderNumber
      data.payTypeName = this.dialogObjs.payType.payTypeName
      data.payTypeCode = this.dialogObjs.payType.payTypeCode
      data.payTime = this.dialogObjs.payTime
      console.log(data)
      let res = await this.$http.post('merchantOrder/updateHistoryOrderOrderDt', data)
      if (res.data.code == 200) {
        this.$message({
          type: 'success',
          message: "修改成功"
        })
        this.getListData()
        this.updateDialog = false
        this.dialogObjs.payType = ''
        this.dialogObjs.payTime = ''
        this.dialogObjs.orderNumber = ''
      } else {
        this.$message.error(res.data.message)
      }
    },
    async getUpSelect() {
      let res = await this.$http.post('merchantOrderPayType/queryList', { merchantCode: localStorage.getItem('merchantCode') })
      this.updateList = res.data.data
    },
    async getCompany() {
      let res = await this.$http.post('miniShangCheng/getDeliveryCompanyList', {})
      this.delivery_list = res.data.data.delivery_list
    },
    async refundBtn() {
      let url = ''
      if (this.isAgreeRefund) { //同意
        url = 'miniShangCheng/agreeRefundOrderHistory'
      } else {
        url = 'miniShangCheng/refuseRefundOrderHistory' //拒绝
      }
      let data = {
        merchantCode: localStorage.getItem('merchantCode'),
        orderNumber: this.dialogObj.orderNumber
      }
      let res = await this.$http.post(url, data)
      console.log(res)
      if (res.data.code == 200) {
        this.showDialogRefund = false
        this.getListData()
        this.$message({
          type: "success",
          message: '操作成功'
        })
      } else {
        this.$message.error(res.data.message)
      }
    },
    showDialogRefundBtn(obj) {
      this.setDialogObj(obj)
      this.showDialogRefund = true
    },
    async showDialog(obj) {
      this.setDialogObj(obj)
      this.getCompany()
      this.dialogVisible = true
    },
    async getDetail(orderNumber) {
      let data = {}
      data.merchantCode = localStorage.getItem('merchantCode')
      data.orderNumber = orderNumber
      let res = await this.$http.post('miniShangCheng/queryOrderItemHistoryList', data)
      return res.data.data
    },
    async deliverBtn() {
      let data = {}
      data.merchantCode = localStorage.getItem('merchantCode')
      if (this.dialogObj.deliveryNo.trim() == '') {
        this.$message.error('请输入快递单号')
        return
      }
      if (this.dialogObj.deliveryCompany.trim() == '') {
        this.$message.error('请输入快递公司名')
        return
      }
      data.orderNumber = this.dialogObj.orderNumber
      data.deliveryNo = this.dialogObj.deliveryNo
      data.deliveryCompany = this.dialogObj.deliveryCompany
      let res = await this.$http.post('miniShangCheng/sendOutGoodsOrderHistory', data)
      if (res.data.code == 200) {
        this.getListData()
        this.dialogVisible = false
        this.$message({
          type: 'success',
          message: '操作成功'
        })
      } else {
        this.$message.error(res.data.message)
      }
    },
    getStatus(row) {
      var status = ''
      let { refundStatus, deliveryType, orderStatus, receiptStatus } = row
      let refundstatusArr = ['未退款', '退款中', '已退款', '拒绝退款']
      let orderstatusArr = ['已下单', '待发货', '待收货', '已完成']
      let receiptStatusArr = ['待接单', '已接单', '拒单', '完成']
      if (refundStatus == 0) { //未退款
        if (deliveryType == '1') { //配送单
          status = orderstatusArr[orderStatus]
        } else {
          status = receiptStatusArr[receiptStatus]
        }
      } else {
        status = refundstatusArr[refundStatus]
      }
      return status
    },
    search() {
      // 获取列表
      if (this.timeType == 0) {
        //下单时间
        delete this.queryInfo.condition.checkOutStartDt
        delete this.queryInfo.condition.checkOutEndDt
        if (this.dateRange == null || this.dateRange.length == 0) {
          this.queryInfo.condition.orderStartDt = null
          this.queryInfo.condition.orderEndDt = null
        } else {
          this.queryInfo.condition.orderStartDt = this.dateRange[0]
          this.queryInfo.condition.orderEndDt = this.dateRange[1]
        }
      } else {
        //结账时间
        delete this.queryInfo.condition.orderStartDt
        delete this.queryInfo.condition.orderEndDt
        if (this.dateRange == null || this.dateRange.length == 0) {
          this.queryInfo.condition.checkOutStartDt = null
          this.queryInfo.condition.checkOutEndDt = null
        } else {
          this.queryInfo.condition.checkOutStartDt = this.dateRange[0]
          this.queryInfo.condition.checkOutEndDt = this.dateRange[1]
        }
      }
      this.getListData()
    },
    searchBystatus(code) {
      this.queryInfo.condition.isRefund = null
      this.queryInfo.condition.receiptStatus = code
      this.search()
    },
    // 已退款
    isRefundBtn() {
      this.queryInfo.condition.isRefund = 1
      delete this.queryInfo.condition.receiptStatus
      this.search()
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getListData()
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize
      this.getListData()
    },
    correct() {
      var temp
      if (
        this.queryInfo.condition.minSumToPay >
        this.queryInfo.condition.maxSumToPay
      ) {
        temp = this.queryInfo.condition.minSumToPay
        this.queryInfo.condition.minSumToPay = this.queryInfo.condition.maxSumToPay
        this.queryInfo.condition.maxSumToPay = temp
      }
    },
    goToDetail(orderNumber) {
      this.$router.push(
        '/statistics/details/order?orderNumber=' +
        orderNumber +
        '&currPage=' +
        this.queryInfo.currPage +
        '&orderType=history'
      )
    },
    /**导出 */
    exportXls() {
      var data = {}
      data.merchantCode = localStorage.getItem('merchantCode')
      data.merchantName = localStorage.getItem('merchantName')
      if (this.timeType == 0) {
        if (this.dateRange == null || this.dateRange == '') {
          data.orderStartDt = null
          data.orderEndDt = null
        } else {
          data.orderStartDt = this.dateRange[0]
          data.orderEndDt = this.dateRange[1]
        }
      } else {
        if (this.dateRange == null || this.dateRange == '') {
          data.orderStartDt = null
          data.orderEndDt = null
        } else {
          data.checkOutStartDt = this.dateRange[0]
          data.checkOutEndDt = this.dateRange[1]
        }
      }
      this.$http.post('/merchantOrderHistorys/exportXls', data).then(res => {
        var link = document.createElement('a')
        link.href = res.data.data
        link.target = '_blank'
        link.download =
          localStorage.getItem('merchantName') +
          moment().format('YYYY/MM/DD') +
          '.xls'
        // link.click()
        window.open(res.data.data)
      })
    },
    /**桌台操作下拉框 */
    getMerchantArea() {
      this.$http
        .post('/merchantAreas/queryList', {
          merchantCode: localStorage.getItem('merchantCode')
        })
        .then(res => {
          this.MerchantAreaList = res.data.data
        })
    },
    /**收银员下拉框 */
    getThreeSelected() {
      this.$http
        .post('/merchantEmployeeRoyaltyArea/queryTableRoyaltyEmployeeList', {
          merchantCode: localStorage.getItem('merchantCode')
        })
        .then(res => {
          this.userCodeListOptions = res.data.data
        })
    },
    //
    getListData() {
      this.tableDloading = true
      var that = this
      that.queryInfo.condition.merchantCode = localStorage.getItem(
        'merchantCode'
      )
      that.$http
        .post('/merchantOrderHistorys/list', that.queryInfo)
        .then(function (response) {
          that.tableDloading = false
          console.log(response.data.data)
          if (response.data.code == 200) {
            that.sumTotal = response.data.data.total
            that.total = response.data.data.pager.count
            that.queryInfo.currPage = response.data.data.pager.currPage
            that.tableData = response.data.data.pager.data
          }
        })
    },
    //
    async setDialogObj(obj) {
      let { orderNumber, refundImg, refundReason, distributorAddress, distributorName, sumPaid, orderDt } = obj
      this.dialogObj.orderNumber = orderNumber
      this.dialogObj.distributorAddress = distributorAddress
      this.dialogObj.distributorName = distributorName
      this.dialogObj.sumPaid = sumPaid
      this.dialogObj.orderDt = orderDt
      this.dialogObj.deliveryNo = ''
      this.dialogObj.deliveryCompany = ''
      this.dialogObj.refundImg = JSON.parse(refundImg)
      this.dialogObj.refundReason = refundReason
      let r = await this.getDetail(orderNumber)
      let arr = []
      r.forEach(item => {
        arr.push({ productName: item.productName, num: item.num })
      })
      this.dialogObj.arr = arr
    },
    //获取修改订单
    async getSetOrder() {
      let res = await this.$http.post('merchantBaseInfo/queryOne', { merchantCode: localStorage.getItem('merchantCode') })
      this.isUpdateOrderTime = parseInt(res.data.data.isUpdateOrderTime)
    },
  },
  created() {
    this.getSetOrder()
    this.queryInfo.condition.merchantCode = localStorage.getItem(
      'merchantCode'
    )
    this.versionCode = localStorage.getItem('versionCode')
    if (this.$route.query.currPage != undefined) {
      this.queryInfo.currPage = this.$route.query.currPage * 1
    }
    this.getMerchantArea()
    this.getThreeSelected()

    let sourceCode = this.$route.query.sourceCode
    if (sourceCode) {
      this.queryInfo.condition.sourceCode = sourceCode
      // this.getListData()
    } else {
      // this.queryInfo.condition.sourceCode = "";
      // this.getListData()
    }
  },
  mounted() {
    this.getListData()
  },
  destroyed() {
  }
}
</script>

<style lang="less" scoped>
::-webkit-scrollbar-thumb {
  border-color: #999;
}

.center-menu {
  display: flex;

  .center-item {
    user-select: none;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    width: 56px;
    height: 46px;
    line-height: 46px;
    font-size: 14px;
    margin-right: 20px;
    cursor: pointer;
  }

  .center-item:hover {
    border-bottom: 2px solid rgb(255, 189, 0);
  }

  .center-item.active {
    border-bottom: 2px solid rgb(255, 189, 0);
  }
}

/deep/ .el-input__suffix {
  top: 4px;
}

/deep/ .ddly-select {
  width: 100%;
}

.search-top {
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
}

//
.main-order-detail {
  h1 {
    color: #333;
    font-weight: 400;
    font-size: 18px;
  }

  .search-top {
    .item {
      display: flex;
      align-items: center;
      margin-bottom: 14px;
      color: rgb(102, 102, 102);
      font-size: 14px;
      margin-right: 20px;

      .button-tag {
        height: 24px;
        font-size: 14px;
        color: rgb(51, 51, 51);
        margin-right: 20px;

        span {
          display: inline-block;
          height: 22px;
          line-height: 22px;
          padding-left: 5px;
          padding-right: 5px;
          margin-left: -1px;
          font-weight: 400;
          text-align: center;
          cursor: pointer;
          user-select: none;
          border-radius: 2px;
          background-color: rgb(255, 255, 255);
          border: 1px solid rgb(229, 229, 229);
        }

        span.active {
          color: rgb(255, 96, 0) !important;
          border-color: rgb(255, 96, 0) !important;
        }
      }
    }
  }
}

/deep/ .el-date-editor--daterange {
  width: 100%;
}

/deep/ .order-time {
  .el-form-item__content {
    width: 215px;
  }
}

/deep/ .el-range-editor--small .el-range-separator {
  line-height: 14px;
}

/deep/ .el-range-editor--small .el-range__icon {
  line-height: 17px;
}

/deep/ .el-select.el-select--small {
  height: 24px !important;
  line-height: 24px;
}

/deep/ .el-input--small .el-input__inner {
  height: 100% !important;
  height: 24px !important;
  line-height: 24px;
}

/deep/ .el-input {
  height: 24px;
}



/deep/ .el-input-number.is-controls-right .el-input-number__decrease {
  height: 12px;
}

/deep/ .el-input-number--small {
  line-height: 24px;
}

/deep/ ::-webkit-scrollbar-thumb {
  background: #999 !important;
}

/deep/ ::-webkit-scrollbar {
  height: 5px;
}

/deep/ .el-input-number.el-input-number--small.is-controls-right {
  span {
    height: 12px;
    line-height: 12px;
  }
}

.sumBtn {
  height: 30px;
  min-width: 100px;
  font-size: 10px;
  padding: 0 10px !important;
  margin-top: 10px;
  flex-wrap: wrap;
}

/deep/ .searchBtn:hover {
  color: #606266;
}

/deep/ i.el-input__clear {
  transform: translateY(-6px);
}

/deep/ .flexCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}

/deep/ .el-dialog__header {
  padding: 16px 20px 10px;
  border-bottom: 1px solid #F3F3F3;

  >span {
    font-size: 16px;
  }
}

/deep/ .el-dialog__headerbtn.el-dialog__close {
  font-size: 20px;

}

/deep/ .mydialog {
  .el-form-item {
    margin-bottom: 12px;
  }

  .el-form-item__content {
    color: #302510;
    font-size: 13px;
  }

  .el-form-item__label::after {
    content: ':';
    padding-left: 2px;
  }

  .el-form-item__label {
    font-size: 15px;
    color: #0A0B0A;
  }
}

/deep/ .el-dialog__body {
  padding-top: 6px;
}

/deep/ .c3 {
  color: #333333;
}

/deep/ .btnTable {
  background: #f59a23;
  color: #212B33;
  font-size: 12px;
  display: flex;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}

/deep/ .workout {
  display: flex;
  justify-content: center;
  align-items: center;

  .cell {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

/deep/ .flexContent {
  .el-form-item__content {
    display: flex;
    flex-direction: column;
  }
}

/deep/ .kuaidi {
  .el-form-item__content {
    display: flex;
  }
}

/deep/ .flex {
  .el-form-item__content {
    display: flex;
  }
}
</style>
